<template>
  <tr>
    <td class="text-xs-left">{{allocation.tip.name}}</td>
    <td class="text-xs-left">{{allocation.spoil.name}}</td>
    <td class="text-xs-left">{{allocation.contractor.name}}</td>
    <td class="text-xs-left">{{allocation.vehicle.name}}</td>
    <td class="text-xs-left">{{allocation.driver.name}}</td>
    <td class="text-xs-left">{{allocation.startTime}}</td>
    <td>
      <div class="justify-center layout px-0">
        <v-btn flat color="grey" icon @click="editDialog = true">
          <v-icon>edit</v-icon>
        </v-btn>
        <v-btn flat color="red lighten-3" icon @click="deleteDialog = true">
          <v-icon>delete</v-icon>
        </v-btn>
      </div>
    </td>

    <v-dialog lazy v-model="deleteDialog" max-width="400px" @keydown.esc="deleteDialog = false">
      <v-card>
        <v-card-title class="headline">Delete?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" flat @click="deleteAllocation()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog lazy v-model="editDialog" max-width="700px" @keydown.esc="editDialog = false">
      <edit-line
        :line="allocation"
        batchEntry
        :batch="{spoilId: $store.state.batchAllocations.spoilId}"
        @close="editDialog = false"
      ></edit-line>
    </v-dialog>
  </tr>
</template>
<script>
import EditLine from "./staging/lines/lineEdit";
export default {
  data() {
    return {
      editDialog: false,
      deleteDialog: false
    };
  },
  methods: {
    deleteAllocation() {
      this.$store.commit("batchAllocations/deleteFromArrayStateByValue", {
        prop: "allocations",
        value: this.allocation
      });
      this.deleteDialog = false;
    }
  },
  props: {
    allocation: Object
  },
  components: {
    EditLine
  }
};
</script>